module.exports = __webpack_public_path__ + "static/media/vintes-logo.ec37918f.png";